// plugins/polyfills.client.js

module.exports = function(context, inject) {
  require('core-js/stable');
  require('regenerator-runtime/runtime');

  // IE11でのみ実行
  const isIE11 = typeof navigator !== 'undefined' && 
                 /Trident.*rv:11\./.test(navigator.userAgent);
  
  if (!isIE11) {
    return;
  }

  if (typeof window !== 'undefined') {
    // Object.assign polyfill
    if (typeof Object.assign !== 'function') {
      Object.assign = function (target) {
        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }
        var to = Object(target);
        
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      };
    }

    // Promise.finally polyfill
    if (typeof Promise !== 'undefined' && typeof Promise.prototype.finally !== 'function') {
      Promise.prototype.finally = function (callback) {
        var P = this.constructor || Promise;
        return this.then(
          function(value) { 
            return P.resolve(callback()).then(function() { return value; }); 
          },
          function(reason) { 
            return P.resolve(callback()).then(function() { throw reason; }); 
          }
        );
      };
    }

    // Element.closest polyfill
    if (typeof Element !== 'undefined' && !Element.prototype.closest) {
      Element.prototype.closest = function (css) {
        var node = this;
        while (node) {
          if (node.matches && node.matches(css)) return node;
          else node = node.parentElement || node.parentNode;
        }
        return null;
      };
    }

    // Element.matches polyfill
    if (typeof Element !== 'undefined' && !Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                  Element.prototype.webkitMatchesSelector ||
                                  function(css) {
                                    try {
                                      var doc = this.document || this.ownerDocument;
                                      var matches = doc.querySelectorAll(css);
                                      var i = matches.length;
                                      while (--i >= 0 && matches.item(i) !== this) {}
                                      return i > -1;
                                    } catch (e) {
                                      return false;
                                    }
                                  };
    }

    // IE11特有の配列メソッド
    if (!Array.prototype.includes) {
      Array.prototype.includes = function(searchElement, fromIndex) {
        return this.indexOf(searchElement, fromIndex) !== -1;
      };
    }

    // String.includes polyfill
    if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
        if (typeof start !== 'number') {
          start = 0;
        }
        return this.indexOf(search, start) !== -1;
      };
    }

    console.log('IE11: Polyfills loaded successfully');
  }
};
